<template>
  <div>
    <slot :amount="amount" :quantity="quantity" :discountRules="discountRules"
          :uniqueDiscountRules="uniqueDiscountRules" :price="discountPrice" :oldPrice="oldPrice"
          :discountPercent="discountPercent" :productStatusBySection="productStatusBySection"
          :multiplicity="multiplicity" :setQuantity="setQuantity" :addToCart="addToCart"
          :errorIndividualPrice="errorIndividualPrice"></slot>
    <confirm-popup v-if="confirmClearCart" @confirm="addToCart(true)" @close="confirmClearCart = false;">
      <div class="confirm-popup__text">
        Оформление с любым другим товаром невозможно.
        Очистить корзину и продолжить оформление?
      </div>
    </confirm-popup>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name:     "Product",
  props:    {
    initial: {
      type:    Object,
      default: () => ({}),
    },
    detail:  {
      type:    Boolean,
      default: false,
    },
  },
  data:     () => ({
    quantity:             1,
    confirmClearCart:     false,
    sectionId:            null,
    errorIndividualPrice: null,
  }),
  computed: {
    productsData()
    {
      return this.$store.state.productsData;
    },
    oldPrice()
    {
      let getPriceIndividual = this.getPriceIndividual();
      if(getPriceIndividual)
      {
        return 0;
      }
      if(this.initial.oldPrice)
      {
        return this.initial.oldPrice;
      }
      else if(
          this.productsData[this.initial.id] &&
          +this.productsData[this.initial.id].oldPrice
      )
      {
        if(this.quantity > 1 && +this.productsData[this.initial.id].oldPriceMulti)
        {
          return +this.productsData[this.initial.id].oldPriceMulti;
        }
        return +this.productsData[this.initial.id].oldPrice || 0;
      }
      else if(this.discountPrice < this.price)
      {
        return this.price;
      }
      return 0;
    },
    discountRules()
    {
      return (this.productsData[this.initial.id] || {}).discountRules || [];
    },
    individualPrice()
    {
      return (this.productsData[this.initial.id] || {}).individualPrice || null;
    },
    uniqueDiscountRules()
    {
      let uniqueDiscountRules = {};
      let sortedDiscountRules = Object.values(this.discountRules).sort((a, b) =>
                                                                       {
                                                                         if(+a.minQuantity == +b.minQuantity)
                                                                         {
                                                                           return 0;
                                                                         }
                                                                         return +a.minQuantity < +b.minQuantity ? -1 : 1;
                                                                       });
      for(let i = 0; i < sortedDiscountRules.length; i++)
      {
        if(
            !uniqueDiscountRules[sortedDiscountRules[i].discount]
            && !sortedDiscountRules[i].saleByBasket
            && !this.initial.isWater
        )
        {
          uniqueDiscountRules[sortedDiscountRules[i].discount] = sortedDiscountRules[i];
        }
      }
      return Object.values(uniqueDiscountRules);
    },
    // вывод процента скидки
    discountPercent()
    {
      let discountPercent = 0;
      if(this.individualPrice)
      {
        if(this.individualPrice.type === 'individual')
        {
          return 'Спец. цена';
        }
        if(parseInt(this.individualPrice.discount) <= 0)
        {
          return 0;
        }
        let basketItems    = this.getBasket;
        //считаем сколько товара в корзине
        let quantityBasket = 0;
        if(basketItems.length)
        {
          for(let key in basketItems)
          {
            if(basketItems[key].productId == this.initial.id && basketItems[key].isIndividual)
            {
              quantityBasket += basketItems[key].quantity;
            }
          }
        }
        if(parseInt(this.individualPrice.maxCount) >= (this.quantity + quantityBasket))
        {
          return this.individualPrice.discount + "%";
        }
      }
      else if((this.productsData[this.initial.id] || {}).discountPercent)
      {
        discountPercent = +(this.productsData[this.initial.id] || {}).discountPercent;
      }
      else if(this.discountRules.length)
      {
        for(let i = 0; i < this.discountRules.length; i++)
        {
          let prevText = "";
          if(this.discountRules[i].saleByBasket)
          {
            prevText = "от ";
          }

          if(this.discountRules[i].minQuantity && this.discountRules[i].discount)
          {

            if(this.quantity == 1 && this.quantity == this.discountRules[i].minQuantity)
            {

              if(this.discountRules[i].discount)
              {
                discountPercent = prevText + this.discountRules[i].discount + "%";
              }
              break;

            }
            else if(this.discountRules[i].minQuantity > 1 && this.quantity >= this.discountRules[i].minQuantity)
            {

              discountPercent = prevText + this.discountRules[i].discount + "%";
              break;

            }

          }
        }
      }
      return discountPercent;
    },
    price()
    {
      let price = null;
      if(this.initial.price)
      {
        price = this.initial.price;
      }
      else if(this.productsData[this.initial.id])
      {
        if(this.quantity > 1 && +this.productsData[this.initial.id].priceMulti)
        {
          price = +this.productsData[this.initial.id].priceMulti;
        }
        else if(this.productsData[this.initial.id].price)
        {
          price = +this.productsData[this.initial.id].price;
        }
      }
      if(price)
      {
        //price = Math.ceil(price);
        price = Math.floor(price);
      }
      return price;
    },
    discountPrice()
    {
      let price = this.price;

      if(this.individualPrice)
      {
        let getPriceIndividual = this.getPriceIndividual();
        if(getPriceIndividual)
        {
          return getPriceIndividual;
        }
        price = Math.floor(price);
      }
      else if(this.discountRules.length)
      {
        for(let i = 0; i < this.discountRules.length; i++)
        {
          if(this.discountRules[i].minQuantity)
          {
            if(this.quantity == 1 && this.quantity == this.discountRules[i].minQuantity)
            {
              if(this.discountRules[i].price)
              {
                price = this.discountRules[i].price;
              }
              else if(this.discountRules[i].discount)
              {
                price -= price / 100 * this.discountRules[i].discount;
                price = Math.floor(price);
              }
              break;
            }
            else if(this.discountRules[i].minQuantity > 1 && this.quantity >= this.discountRules[i].minQuantity)
            {
              if(this.discountRules[i].price)
              {
                price = this.discountRules[i].price;
              }
              else if(this.discountRules[i].discount)
              {
                price -= price / 100 * this.discountRules[i].discount;
                price = Math.floor(price);
              }
              break;
            }
          }
        }
      }

      return price;
    },
    producerPrice()
    {
      if(this.initial.producerPrice)
      {
        return this.initial.producerPrice;
      }
      else if(this.productsData[this.initial.id])
      {
        return +this.productsData[this.initial.id].producerPrice || 0;
      }
      return null;
    },
    amount()
    {
      let amount = null;
      if(this.productsData[this.initial.id])
      {
        amount = 0;

        if(this.productsData[this.initial.id].isService)
        {
          return 5000;
        }

        if(this.productsData[this.initial.id].amount)
        {
          // суммируем остатки со всех доступных складов
          amount = Object.values(this.productsData[this.initial.id].amount).reduce((p, c) => p + c);
        }
      }
      return amount;
    },
    multiplicity()
    {

      let multiplicity = 1;
      if(+this.initial.countInPackage)
      {
        multiplicity = this.initial.countInPackage;
      }
      // else
      // {
      //     if (
      //         this.initial.isWater &&
      //         this.initial.weight
      //     )
      //     {
      //         if ( this.initial.weight == 5000 )
      //         {
      //             multiplicity = 2;
      //         }
      //         else if ( this.initial.weight == 3000 )
      //         {
      //             multiplicity = 3;
      //         }
      //         else if ( this.initial.weight == 1500 || this.initial.weight == 700 )
      //         {
      //             multiplicity = 6;
      //         }
      //         else if ( this.initial.weight == 1000 )
      //         {
      //             multiplicity = 9;
      //         }
      //         else if ( this.initial.weight == 500 )
      //         {
      //             multiplicity = 12;
      //         }
      //         else if ( this.initial.weight == 330 )
      //         {
      //             multiplicity = 12;
      //         }
      //     }
      // }
      return multiplicity;
    },
    productStatusBySection()
    {
      if(this.sectionId == 334)
      {
        return "от ";
      }
      return "";
    },
    getBasket()
    {
      return this.$store.state.cart.items || [];
    },
  },
  mounted()
  {

    if(this.initial?.sectionId)
    {
      this.sectionId = this.initial.sectionId;
    }

    if(+this.initial.countInPackage)
    {
      this.quantity = this.initial.countInPackage;
    }
    else
    {
      this.quantity = this.multiplicity == 1 && this.initial.weight == 19000 ? 2 : this.multiplicity;
    }


    if(this.price == null)
    {
      this.$store.dispatch("loadProductData", {
        productId: this.initial.id,
      });
    }

    let i                      = 0;
    let loadProductDataTimeout = setInterval(() =>
                                             {
                                               if(i > 6)
                                               {
                                                 clearInterval(loadProductDataTimeout);
                                               }
                                               if(this.productsData[this.initial.id])
                                               {
                                                 //цена за 2 и более меньше - ставим количество 2
                                                 if(+this.quantity == 1 && this.productsData[this.initial.id])
                                                 {
                                                   if(+this.productsData[this.initial.id].priceMulti < +this.productsData[this.initial.id].price)
                                                   {
                                                     this.quantity = 2;
                                                   }
                                                 }
                                                 clearInterval(loadProductDataTimeout);
                                               }
                                               else
                                               {
                                                 i++;
                                               }
                                             }, 1000);

    if(this.detail)
    {
      this.$root.VKRetargetingProductEvent("view_product", {
        currency_code: "RUR",
        products:      [
          {
            id: this.initial.id,
          },
        ],
      });
    }
    if(!this.getBasket.length)
    {
      this.$store.dispatch("loadCartData");
    }

  },
  methods: {
    setQuantity(quantity)
    {
      this.quantity = quantity;
    },
    addToCart(forced)
    {
      if(this.$root.catalogClass.loading)
      {
        return false;
      }
      this.$root.catalogClass.loading = true;
      let data                        = new FormData;
      data.append("products[0][id]", this.initial.id);
      data.append("products[0][quantity]", this.quantity);
      if(forced)
      {
        data.append("force_add", true);
        this.$store.dispatch("clearPetPromo");
      }
      fetch("/api/v1/products/add-to-cart/", {
        method: "POST",
        body:   data,
      })
          .then(res => res.json())
          .then((result) =>
                {
                  this.$root.catalogClass.loading = false;
                  Cookies.remove("orderDeliveryDate");
                  Cookies.remove("orderDeliveryTime");
                  if(result && result.error)
                  {
                    switch(result.error)
                    {
                        //если в корзине уже есть товар другого типа
                      case "several_types":
                        this.confirmClearCart = true;
                        break;
                    }
                  }
                  else
                  {
                    if(result && result.messages && result.messages.length)
                    {
                      this.$root.showMessages(result.messages);
                    }
                    else
                    {

                      if(!this.$root.userData.isUserPricesEnabled)
                      {
                        this.$root.alert(`<a href='/personal/cart'>Товар добавлен в корзину.<br>Стоимость увеличена, так как выбран 2-х часовой интервал.</a>`, "success", 2.5);
                      }
                      else
                      {
                        this.$root.alert(`<a href='/personal/cart'>Товар добавлен в корзину</a>`);
                      }
                    }
                    this.$store.dispatch("loadCartData");
                    this.$root.VKRetargetingProductEvent("add_to_cart", {
                      currency_code: "RUR",
                      products:      [
                        {
                          id: this.initial.id,
                        },
                      ],
                    });

                    if(result && result.mainbox)
                    {
                      for(let ind in result.mainbox)
                      {
                        this.$root.sendMainBoxItem(result.mainbox[ind]);
                      }
                    }

                  }

                }).catch(() =>
                         {
                           this.$root.catalogClass.loading = false;
                           this.$root.alert("Непредвиденная ошибка", "error");
                         });
    },
    getPriceIndividual()
    {

      let availableQuantityIndividual = parseInt(this.individualPrice?.availableQuantity);
      if(this.individualPrice)
      {
        if(!this.individualPrice?.error)
        {

          let basketItems    = this.getBasket;
          //считаем сколько товара в корзине
          let quantityBasket = 0;
          if(basketItems.length)
          {
            for(let key in basketItems)
            {
              if(basketItems[key].productId == this.initial.id && basketItems[key].isIndividual)
              {
                quantityBasket += basketItems[key].quantity;
              }
            }
          }
          this.errorIndividualPrice = null;

          if(quantityBasket && quantityBasket >= this.individualPrice.maxCount)
          {
            this.errorIndividualPrice = null;
            return;
          }

          let priceBuy = this.individualPrice.price;
          if(this.quantity > 1)
          {
            priceBuy = this.individualPrice.priceMulti;
          }

          if(parseInt(this.individualPrice.maxCount)>0 && parseInt(this.individualPrice.maxCount) < (this.quantity + quantityBasket))
          {
            this.errorIndividualPrice = "Доступно по индивидуальной цене " + priceBuy + "&nbsp;₽ только " + availableQuantityIndividual + "шт. ";
          }
          else
          {
            this.errorIndividualPrice = null;
            return priceBuy;
          }
        }
        else
        {
          this.errorIndividualPrice = this.individualPrice.error;
        }
      }
      return;
    },
  },
  watch:   {
    quantity(val)
    {
      if(val < this.multiplicity || +val % this.multiplicity)
      {
        setTimeout(() =>
                   {
                     this.quantity = +this.multiplicity;
                   }, 100);
      }
    },
    discountRules()
    {
      /*if (this.discountRules.length) {
       if(this.discountRules[0].quantity) {
       this.quantity = +this.discountRules[0].minQuantity;
       }
       }*/
    },
  },
};
</script>
